<template src="../templates/normal_fcont_148.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import DesignPaperTiles from '../components/DesignPaperTiles'
import PrintButton from '../components/PrintButton'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '148',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    DesignPaperTiles,PrintButton,ReleaseDateForArticle
  },
  computed: {
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['148-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['148-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
.indent_caption_148 {
  margin-top: 30px;
}
</style>

